import Component from "@ember/component"
import { inject as service } from "@ember/service"
import type { FiscalGroup } from "@shared/models/fiscal-group"

export default class AdminDetailFiscalGroup extends Component {
  @service notifier
  @service("ember-store") store
  @service rpc

  model: null | FiscalGroup = null
}
